import { Component, Input, EventEmitter, Output } from '@angular/core';
import { BlockComponent } from '../block-organizer';

@Component({
  standalone: false,
  selector: 'physician-block',
  templateUrl: './physician-block.component.html',
  styleUrls: ['../tileblocks.component.scss', './physician-block.component.scss']
})
export class PhysicianBlockComponent implements BlockComponent {
  @Input() block: any;
  @Output() physicianView = new EventEmitter<any>();
  constructor() { }

  public onChange(e: any) {
    e.preventDefault();
    this.physicianView.emit({ 'action': 'physicianView', block: this.block });
  }
}
